import { ChangeDetectionStrategy, Component } from "@angular/core";
import { i18nScope } from "../../utils";

@Component({
  selector: "lib-hr-separator",
  templateUrl: "./hr-separator.component.html",
  styleUrls: ["./hr-separator.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HrSeparatorComponent {
  i18nScope = i18nScope;
}
